<template>
  <div>
    <ul
      role="tree"
      aria-multiselectable="true"
      class="sammio-treeview"
      :aria-labelledby="labelledby"
      :aria-describedby="describedby"
    >


    <li
        v-for="(element,index) in elements"
        :key="element.ordinal"
        class="sammio-treeview--leaf leaf-main"
        role="none"
    >
        <div
            role="treeitem"
            tabindex="0"
            class="sammio-treeview__node sammio-treeview--element"
            :aria-owns="identifier + '_subtree_' + element.ordinal"
            :aria-selected="element.checked ? 'true' : 'false'"
            :aria-checked="element.checked ? 'true' : 'false'"
            :aria-expanded=" element.showChildren ? 'true' : 'false'"
            :aria-posinset="(index + 1)"
            aria-level="1"
            @keydown.left="closeDropdown($event, element)"
            @keydown.right="openDropwdown($event, element)"
            @keydown="keyEvent($event, element)"

        >
          <span
              tabIndex="-1"
              :aria-checked="element.checked ? 'true' : 'false'"
              @click="isChecked(element)"
              @keyup.enter="isChecked(element)"
              aria-hidden="true"
              class="sammio-treeview__checkbox"
          >
            <sammio-check-box-on v-if="element.checked" />
            <sammio-check-box-off v-else />
          </span>
          <span
              tabindex="0"
              @click="toggleChildren(element)"
              :id="identifier + '_treeMainItem_' + index"
              class="sammio-treeview__title"
          >
            <span aria-hidden="true">{{ element.label }}</span>
            <span class="sr-only" aria-live="polite">{{ element.label }} {{ element.checked ? $t('sammio.selected') : $t('sammio.unselected')}}</span>
          </span>
          <span
              aria-hidden="true"
              @click="toggleChildren(element)"
              v-if="hasChildren(element)"
              :class="element.showChildren ? 'sammio-treeview__icon--active' : '' + ' sammio-treeview__icon'"
          >
            <sammio-chevron-up />
          </span>
        </div>
        <ul
            v-if="element.showChildren"
            class="sammio-treeview sammio-treeview__group"
            role="group"
            :id="identifier + '_subtree_' + index"
        >
          <li
              v-for="(child, i) in element.children"
              :key="i"
              role="treeitem"
              :aria-selected="child.checked ? 'true' : 'false'"
              class="sammio-treeview__node"

          >
              <span
                  aria-hidden="true"
                  tabindex="-1"
                  @click="isChildChecked(element,i)"
                  class="sammio-treeview__checkbox"
              >
                <sammio-check-box-on v-if="child.checked" />
                <sammio-check-box-off v-else />
              </span>
              <span
                  tabindex="0"
                  class="sammio-treeview__title sammio-treeview--child"
                  :aria-selected="child.checked ? 'true' : 'false'"
                  :aria-checked="child.checked ? 'true' : 'false'"

                  @keyup="keyEventChild($event, child, element, i)"
                  @click="isChildChecked(element,i)"
                  :aria-posinset="(i + 1)"
                  :aria-level="2"
                  aria-live="polite"
                >
                <span aria-hidden="true"> {{child.label}}</span>
                <span class="sr-only" >{{child.label}} {{ child.checked ? $t('sammio.selected') : $t('sammio.unselected') }}</span>
              </span>

          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>

  import SammioCheckBoxOn from "@/components/icons/CheckboxChecked";
  import SammioCheckBoxOff from "@/components/icons/Checkbox";
  import SammioChevronUp from "@/components/icons/ChevronDown";

  export default {
    name: "SammioTreeview",
    props: [
        'items',
        'item-label',
        'item-key',
        'labelledby',
        'describedby',
        'selected',
        'active',
        'selected',
        'identifier'
    ],
    components: {
      SammioCheckBoxOff,
      SammioCheckBoxOn,
      SammioChevronUp
    },
    data() {
      return {
        elements: [],
        result: []
      }
    },
    mounted() {
        // initialize data
        if (this.items && this.items.length > 0) {

          // Add props items to data
          const newArray = [...this.items]

          // Add needed values to prop data
          const cb = (e) => {
            this.$set(e, 'checked', false);
            this.$set(e, 'dirty', false);
            this.$set(e, 'keep', false);
            this.$set(e, 'showChildren', false);
            // iterate items and their children
            e.children && e.children.forEach(cb);
          }

          newArray.forEach(cb);
          this.elements = newArray;

          // if this.selected contains IDs
          // mark them checked in treeview
          if (this.selected && this.selected.length > 0 ) {

            const cb = (e) => {
              if (this.selected.includes(e.categoryId)) {
                this.$set(e, 'checked', true);

                // set open if item has children
                if (e.children.length > 0 ) {
                  this.$set(e, 'showChildren', true);
                }
              }
              e.children && e.children.forEach(cb);
            }
            this.elements.forEach(cb);
          }
        }
    },
    computed: {},
    methods: {
      closeDropdown(evt,element)  {
        element.showChildren = false;
        const EL = evt.target;
        if (EL.classList.contains('sammio-treeview--leaf')) {
          EL.firstChild.focus();
        } else {
          const firstChild = EL.closest('.leaf-main').firstChild;
          firstChild.focus();
        }
      },
      openDropwdown(evt,element) {
        element.showChildren = true;
      },
      isChecked(element) {
        // Change checked status
        element.checked = !element.checked;
        // Set dirty state true
        element.dirty = true;

        // If checkbox is checked, check all children if they are not clicked earlier
        // else if dirty
        if ( element.checked ) {
          if (element.children) {
            // Reveal children
            element.showChildren = true;

            // iterate children and change their checked status
            element.children.forEach(child => {
              if (!child.dirty && !element.keep ) {
                child.checked = true;
                child.dirty = true;
              }
            })
            element.keep = true;
          }
        }
      },
      isChildChecked(parent, child) {
        parent.children[child].checked = !parent.children[child].checked;

      },
      hasChildren(parent) {
        if (parent.children && parent.children.length > 0) {
          return true;
        }
      },
      toggleChildren(item) {
          this.$set(item,'showChildren', !item.showChildren);
      },
      keyEvent(evt,element) {
        const KEY = evt.key;
        const EL = evt.target;
        let flag = false;

        switch (KEY) {
          case 'ArrowUp':
            const prevSibling = EL.closest('li').previousSibling;
            // If has previous sibling
            if (prevSibling) {

              // Check if prev element is expanded
              const expanded = prevSibling.getAttribute('aria-expanded');
              if (expanded === 'true') {

                const group = prevSibling.querySelectorAll('[role="group"]')[0];
                //
                // If previous sibling has children visible, focus on last element
                //
                // get all children
                const children = group.querySelectorAll('.sammio-treeview--child');
                // get the index of last child
                const lastIndex = children.length - 1;
                // focus on last child

                children[lastIndex].focus();
              } else {
                // Focus on previous sibling
                const span = prevSibling.querySelectorAll('div.sammio-treeview--element')[0];
                span.focus();
              }

            }
            flag = true;
            break;
          case 'ArrowDown':
            if (element.showChildren) {
              // move focus to first child
              let parent = null;
              if (EL.classList.contains('sammio-treeview--leaf')) {
                parent = EL;
              } else {
                parent = EL.closest('li');
              }

              const firstChildContainer = parent.querySelectorAll('li')[0];
              const firstChild = firstChildContainer.querySelectorAll('.sammio-treeview--child')[0];

              if (firstChild) {
                firstChild.focus();
              }
              flag = true;
            } else {
              // move focus to next sibling
              const nextSibling = EL.closest('li').nextSibling;
              if (nextSibling !== null) {
                const span = nextSibling.querySelectorAll('div.sammio-treeview--element')[0];
                span.focus();
              }
            }
            flag = true;
            break;
          case 'Enter':
            this.isChecked(element);
            flag = true;
            break;

        }

        if (flag) {
          evt.stopPropagation();
          evt.preventDefault();
        }
      },
      keyEventChild(evt,element,parent, index) {
        const KEY = evt.key;
        const EL = evt.target;
        const prevSiblingEl = EL.parentElement.previousSibling;
        const nextSiblingEl = EL.parentElement.nextSibling;
        const parentEl = EL.parentElement.parentElement;

        switch (KEY) {
          case 'ArrowUp':

            if (prevSiblingEl) {
              // move to previous child
              //prevSiblingEl.focus();
              const prev = prevSiblingEl.querySelectorAll('.sammio-treeview--child')[0];

              prev.focus();
            } else {
              // if first element, move back to parent
              if (parentEl) {
               const prevSibling = parentEl.previousSibling;

               if (prevSibling) {
                 prevSibling.focus();
               }
              }
            }
            break;
          case 'ArrowDown':
            if (nextSiblingEl) {
              // If it not last child move to next one
              const next = nextSiblingEl.querySelectorAll('.sammio-treeview--child')[0];
              next.focus();
            } else {
              // if is last child
              if (parentEl) {
                // Find next parent element
                const parentNextSibling = parentEl.closest('.leaf-main').nextSibling;

                if (parentNextSibling) {
                  // if next parent has next sibling, focus on it
                  const firstChild = parentNextSibling.firstElementChild;
                  firstChild.focus();
                }
              }
            }
            break;
          case 'Enter':
            // Set check status of element
            this.isChildChecked(parent,index);
            break;

        }
      }

    },
    watch: {
      items: {
        handler: function() {
          // Listen changes to this.items
          this.elements.forEach((item, index) => {
            if (this.elements[index].label !== this.items[index].label) {
              // change label value when item[index].label value is different eg. when changing language
              item.label = this.items[index].label;
              if (item.children) {
                item.children.forEach((child, i) => {
                  child.label = this.items[index].children[i].label;
                });
              }
            }
          });
        },
        deep: true
      },
      elements: {
        handler: function() {
         // If element is checked add it to array
         // Init result data

          this.result = [];
          // Iterate this.elements
          // if item is checked add its categoryId to this.results
          const cb = (e) => {
            if (e.checked) {
              this.$set(this.result,this.result.length, e.categoryId);
            }
            // iterate items and their children
            e.children && e.children.forEach(cb);
          }
          // Go thru elements
          this.elements.forEach(cb);

          // Send result to parent component
          this.$emit('input', this.result);
        },
        deep: true
      },
      active: {
        immediate: true,
        handler: function(val,oldV) {
          // check if e.categoryId value is not listed on [val] array, set checked value to false
          const cb = (e) => {
            if (!val.includes(e.categoryId)) {
              this.$set(e, 'checked', false);
            }
            e.children && e.children.forEach(cb);
          }

          // iterate tnru this.elements to remove checked value from those which were removed by user in search element
          this.elements.forEach(cb);

        }
      }
    }
  }
</script>
<style lang="scss">
  .sammio-treeview {
    list-style-type: none;
    padding: 0;
    margin: 0;

    span[role="button"] {
      cursor: pointer;
    }
  }

  .sammio-treeview__node {
    padding: 0.8125rem 0.9375rem;
    position: relative;
    display: flex;
    background-color: #fff8ea;
    border-bottom: 1px solid #cecece;
    margin: 0;

    .sammio-treeview__title {
      cursor: pointer;
    }

    span[role="checkbox"] {
     height: 1.313rem;
    }

  }

  .sammio-treeview__group {
    padding-left: 0.9375rem;
    width: 100%;

    .sammio-treeview__node {
      background: transparent;
    }
  }

  .sammio-treeview__title {
    margin-right: 1.25rem;
    margin-left: 0.9375rem;
    width: 100%;
    max-width: 75%;
  }

  span[class*="sammio-treeview__icon"]{
    cursor: pointer;
  }

  .sammio-treeview__icon {
    flex: 0 0 24px;
    left: auto;
    > svg {
      transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), visibility 0s;
      transform: rotate(0);

      > g > path { stroke-width: 3; }
    }

    &--active {

      > svg {
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), visibility 0s;
        transform: rotate(180deg);

        > g > path { stroke-width: 3; }
      }
    }
  }
  .sammio-treeview__checkbox {
    cursor:pointer;
  }
  *:focus,
  [tabindex="-1"]:focus {
    outline: 2px solid #53bdbd !important;
    outline-offset: 2px;
  }

</style>